import { render } from "./ProblemList.vue?vue&type=template&id=33adfd54&scoped=true"
import script from "./ProblemList.vue?vue&type=script&lang=js"
export * from "./ProblemList.vue?vue&type=script&lang=js"

import "./ProblemList.vue?vue&type=style&index=0&id=33adfd54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33adfd54"]])

export default __exports__